import { __require as s } from "./isFunction.js";
import { __require as a } from "./isLength.js";
var e, i;
function _() {
  if (i) return e;
  i = 1;
  var n = s(), t = a();
  function u(r) {
    return r != null && t(r.length) && !n(r);
  }
  return e = u, e;
}
export {
  _ as __require
};
